<template>
	<!-- <car-camera /> -->
	<div class="head">
		<img src="@/assets/header.png" alt="" />
	</div>
	<van-form
		ref="carInfoRef"
		label-width="100"
		class="r-40 bg-white g-relative pt-2"
	>
		<div class="title">
			<p ref="carInfoTitleRef">行驶证信息</p>
		</div>
		<flex-box class="photo-box" justify="center" gap="1.2em">
			<van-field
				:model-value="formData.carInfo.driverLicenseTop"
				:border="false"
				:rules="[
					{
						validator: (file) => !!file && file.status == 'success',
						message: '请上传行驶证正面'
					}
				]"
			>
				<template #input>
					<CardCamera
						v-model="formData.carInfo.driverLicenseTop"
						card-type="car-top"
						@after-read="afterReadDrive"
					></CardCamera>
				</template>
			</van-field>
			<van-field
				:model-value="formData.carInfo.driverLicenseReverse"
				:border="false"
				:rules="[
					{
						validator: (file) => !!file && file.status == 'success',
						message: '请上传行驶证背面'
					}
				]"
			>
				<template #input>
					<CardCamera
						v-model="formData.carInfo.driverLicenseReverse"
						@after-read="afterReadNormal"
						card-type="car-reverse"
					></CardCamera>
				</template>
			</van-field>
		</flex-box>

		<div class="title">
			<p ref="carNumberTitleRef">车牌号码</p>
		</div>
		<van-field
			name="cardNumber"
			placeholder="信息保密，仅用于投保"
			:border="false"
			:rules="[{ validator: validatorCarNumber, message: '请输入正确车牌号' }]"
		>
			<template #input>
				<car-number ref="carNumberRef" style="flex: 1" />
			</template>
		</van-field>

		<div class="title">
			<p ref="carInfoTitleRef">车辆信息</p>
		</div>
		<van-field
			clearable
			v-model="formData.carInfo.name"
			name="name"
			label="所有人"
			placeholder="请输入，信息仅用于投保"
			:rules="[
				{
					required: true,
					message: '请输入车辆所有人'
				}
			]"
		/>
		<van-field
			clearable
			v-model="formData.carInfo.carType"
			name="carType"
			label="品牌车型"
			placeholder="请输入，信息仅用于投保"
			:rules="[
				{
					required: true,
					message: '请输入品牌车型'
				}
			]"
		/>
		<van-field
			clearable
			v-model="formData.carInfo.cardVin"
			name="cardVin"
			label="车辆识别代码"
			placeholder="请输入，信息仅用于投保"
			:rules="[
				{
					required: true,
					message: '请输入车架号(车辆统一识别代号)'
				}
			]"
		/>
		<van-field
			is-link
			:model-value="formData.carInfo.registrationTimeArr.join('-')"
			name="registrationTime"
			label="注册日期"
			@click="registrationTimeShow = true"
			placeholder="请输入，信息仅用于投保"
			:rules="[
				{
					required: true,
					message: '请选择注册日期'
				}
			]"
		/>
		<DatePopup
			:model-value="formData.carInfo.registrationTimeArr"
			@update:model-value="onDatePopupChange"
			v-model:show="registrationTimeShow"
		/>

		<div class="title">
			<p ref="cardInfoTitleRef">身份证信息</p>
		</div>
		<flex-box class="photo-box" justify="center" gap="1.2em">
			<van-field
				:model-value="formData.personInfo.idCardTop"
				:border="false"
				:rules="[
					{
						validator: (file) => {
							debugger
							return !!file && file.status == 'success'
						},
						message: '请上传身份证人像面'
					}
				]"
			>
				<template #input>
					<CardCamera
						v-model="formData.personInfo.idCardTop"
						@after-read="afterReadIdCard"
						card-type="id-top"
					></CardCamera>
				</template>
			</van-field>
			<van-field
				:model-value="formData.personInfo.idCardReverse"
				:border="false"
				:rules="[
					{
						validator: (file) => !!file && file.status == 'success',
						message: '请上传身份证国徽面'
					}
				]"
			>
				<template #input>
					<CardCamera
						v-model="formData.personInfo.idCardReverse"
						@after-read="afterReadNormal"
						card-type="id-reverse"
					></CardCamera>
				</template>
			</van-field>
		</flex-box>
		<van-field
			clearable
			v-model="formData.personInfo.name"
			name="name"
			label="姓名"
			placeholder="信息保密，仅用于投保"
			:rules="[
				{
					validator: (val) => REGEXP.zh.test(val) && val.length > 1,
					message: '请输入姓名'
				}
			]"
		/>
		<van-field
			v-model="idTypeText"
			is-link
			readonly
			placeholder="信息保密，仅用于投保"
			label="证件类型"
			@click="showIdTypePicker = true"
		/>
		<van-field
			v-model="formData.personInfo.idType"
			name="idType"
			style="display: none"
		/>
		<van-popup v-model:show="showIdTypePicker" position="bottom">
			<van-picker
				:columns="idTypeColumns"
				@confirm="onIdTypeConfirm"
				@cancel="showIdTypePicker = false"
			/>
		</van-popup>
		<van-field
			clearable
			label="证件号码"
			v-model="formData.personInfo.idNumber"
			name="idNumber"
			placeholder="信息保密，仅用于投保"
			:rules="[
				{
					required: true,
					message: '请填写证件号码'
				}
			]"
		>
		</van-field>
		<van-field
			clearable
			label="地址"
			v-model="formData.personInfo.address"
			name="address"
			placeholder="信息保密，仅用于投保"
			:rules="[
				{
					required: true,
					message: '请填写地址'
				}
			]"
		></van-field>
		<van-field
			clearable
			label="手机号"
			v-model="formData.personInfo.contactPhone"
			name="contactPhone"
			maxlength="11"
			placeholder="信息保密，仅用于投保"
			:rules="[
				{
					required: true,
					message: '请填写手机号'
				}
			]"
		></van-field>
	</van-form>
	<!-- <div class="form">
		<div class="foot">
			<van-checkbox v-model="agreeReaded"></van-checkbox>
			请您详细阅读并同意
			<span
				v-for="agree in agrees"
				class="em"
				@click="onShowAgreePopup(agree.name)"
				>{{ agree.name }}</span
			>
		</div>
		<div class="button">
			<button ref="submit" @click="onSubmit">
				<img class="btn" src="./T8cd43005a3fa4e33a9c3bed30a005de5.png" alt="" />
			</button>
			<img class="point" src="./point.webp" alt="" />
		</div>
	</div> -->
	<div class="m-3">
		<van-button @click="onSubmit" type="primary" block>立即提交</van-button>
	</div>
	<agree-popup
		ref="agreePopupRef"
		v-model:show="showAgreePopup"
		:agrees="agrees"
		@read-end="onAgreeEnd"
	/>
	<div class="fix-place"></div>
</template>

<script>
import {
	uploadFile,
	createBusiness,
	licenseOcr,
	idCardOcr,
	driveOcr,
	productDetail,
	goPay,
	saveInsuranceInfoByYG
} from '@/api/index'
import { showToast, showLoadingToast, showFailToast, closeToast } from 'vant'
import qs from 'qs'
import * as REGEXP from '@/const/REGEXP'
import AgreePopup from './agree'
import CarNumber from '@/views/components/CarNumber'
import DatePopup from '@/components/date-popup'
import CardCamera from '@/views/components/CardCamera'
const URL_QUERY = qs.parse(location.search.slice(1))

const merge = (target, source) => {
	for (let key in source) target[key] = source[key]
	return target
}
export default {
	name: 'HomeView',
	components: { AgreePopup, CarNumber, DatePopup, CardCamera },
	data() {
		const validatorCarNumber = (value, rule) => {
			return this.$refs.carNumberRef.validate().catch((err) => {
				return err.message
			})
		}

		return {
			validatorCarNumber,
			isDev: process.env.NODE_ENV == 'development',
			loadingText: '',
			REGEXP,
			agreeReaded: false,
			showAgreePopup: false,

			activeGuaId: null,
			productDetail: null,
			showIdTypePicker: false,
			idTypeText: '',
			idTypeColumns: [
				{ text: '身份证', value: 0 },
				{ text: '出生证', value: 1 },
				{ text: '护照', value: 2 },
				{ text: '军人证', value: 3 },
				{ text: '在华居住证', value: 4 },
				{ text: '台湾居民往来大陆通行证', value: 5 },
				{ text: '港澳居民往来内地通行证', value: 6 },
				{ text: '国人永久居留身份证', value: 7 },
				{ text: '居民户口簿', value: 8 }
			],
			formData: {
				// corporate: {
				// 	license: [],
				// 	address: '',
				// 	certNum: '',
				// 	contactName: '',
				// 	customerName: '',
				// 	contactPhone: ''
				// },
				personInfo: {
					name: process.env.NODE_ENV === 'development' ? '叶润' : '', // 客户名称
					idType: '', // 证件类型
					idNumber:
						process.env.NODE_ENV === 'development' ? '350681199511050010' : '', // 证件号码
					contactPhone: '', //手机号
					birthday: '', // 出生日期（个人客户专用）
					gender: '', // 性别（1表示男性，0表示女性）
					address: '', // 地址
					idCardTop: null, // 身份证照片
					idCardReverse: null
				},
				carInfo: {
					cardNumber: '', //车牌号
					cardVin: '', //车架号
					name: '',
					carType: '',
					registrationTimeArr: [], //注册日期
					approvedSeating: '',
					tonnage: '',
					engineNumber: '',
					driverLicenseTop: null,
					driverLicenseReverse: null
				}
			},

			agrees: [], // 协议列表
			registrationTimeShow: false
		}
	},
	computed: {
		productId() {
			return this.$route.query.productId || 11653
		}
	},
	mounted() {},
	methods: {
		onIdTypeConfirm({ selectedOptions }) {
			this.idTypeText = selectedOptions[0]?.text
			this.formData.personInfo.idType = selectedOptions[0]?.value
			this.showIdTypePicker = false
		},
		onShowAgreePopup(name) {
			this.showAgreePopup = true
			this.$nextTick(() => this.$refs.agreePopupRef.scrollTo(name))
		},
		onDatePopupChange(dateValue) {
			console.log('dateValue', dateValue)
			this.formData.carInfo.registrationTimeArr = dateValue
		},
		async onSubmit() {
			await this.$refs.carInfoRef.validate()
			showLoadingToast('正在提交')
			console.log(this.formData.personInfo)
			var postData = {
				...this.formData,
				registrationTime: this.formData.carInfo.registrationTimeArr.join('-'),
				cardNumber: this.$refs.carNumberRef.carNumber.join(''),
				file: [
					{
						name: 'idCardTop',
						batchId: this.formData.personInfo.idCardTop.servFile.batchId
					},
					{
						name: 'idCardReverse',
						batchId: this.formData.personInfo.idCardReverse.servFile.batchId
					},
					{
						name: 'driverLicenseTop',
						batchId: this.formData.carInfo.driverLicenseTop.servFile.batchId
					},
					{
						name: 'driverLicenseReverse',
						batchId: this.formData.carInfo.driverLicenseReverse.servFile.batchId
					}
				]
			}

			saveInsuranceInfoByYG(postData).then(({ data: servData }) => {
				showToast('投保信息已提交')
				console.log({
					batchId: this.batchId
				})
				Recorder.submit({
					batchId: this.batchId
				})
				this.$router.push('/success')
			})
		},

		onAgreeEnd() {
			this.agreeReaded = true
			this.showZhapianPopup = true
		},

		async afterReadLicense(fileProxy) {
			try {
				fileProxy.status = 'uploading'
				fileProxy.message = '上传中...'
				fileProxy.servFile = await uploadFile({ file: fileProxy.file })
			} catch (e) {
				fileProxy.status = 'failed'
				fileProxy.message = '上传失败'
				console.error(e)
				return
			}
			try {
				fileProxy.status = 'uploading'
				fileProxy.message = '识别中...'
				let ocrData = await licenseOcr(fileProxy.servFile)
				merge(this.formData.corporate, ocrData.data)
			} catch (e) {
				fileProxy.status = 'failed'
				fileProxy.message = '识别失败'
				console.error(e)
				return
			}
			fileProxy.status = 'success'
			fileProxy.message = '识别成功'
		},
		async afterReadIdCard(fileProxy) {
			try {
				fileProxy.status = 'uploading'
				fileProxy.message = '上传中...'

				fileProxy.servFile = await uploadFile({ file: fileProxy.file })
			} catch (e) {
				fileProxy.status = 'failed'
				fileProxy.message = '上传失败'
				console.error(e)
				return
			}

			try {
				fileProxy.status = 'uploading'
				fileProxy.message = '识别中...'
				let ocrData = await idCardOcr(fileProxy.servFile)
				merge(this.formData.personInfo, ocrData.data)
				this.formData.personInfo.idType = 0
				this.idTypeText = '身份证'
			} catch (e) {
				fileProxy.status = 'failed'
				fileProxy.message = '识别失败'
				console.error(e)
				return
			}
			fileProxy.status = 'success'
			fileProxy.message = '识别成功'
		},
		async afterReadDrive(fileProxy) {
			try {
				fileProxy.status = 'uploading'
				fileProxy.message = '上传中...'
				fileProxy.servFile = await uploadFile({ file: fileProxy.file })
			} catch (e) {
				fileProxy.status = 'failed'
				fileProxy.message = '上传失败'
				console.error(e)
				return
			}
			try {
				fileProxy.status = 'uploading'
				fileProxy.message = '识别中...'
				let ocrData = await driveOcr(fileProxy.servFile)
				merge(this.formData.carInfo, ocrData.data)
				this.formData.carInfo.cardVin = ocrData.data.vehicleIdentificationNumber
				this.formData.carInfo.tonnage = ocrData.data.grossWeight
				this.formData.carInfo.registrationTimeArr =
					ocrData.data.issueTime.split('-')
				this.formData.carInfo.carType = ocrData.data.carType
				this.formData.carInfo.name = ocrData.data.ownerName
				this.formData.carInfo.approvedSeating = ocrData.data.seatingCapacity
				this.$refs.carNumberRef.setCarNumber(ocrData.data.licensePlateNumber)
			} catch (e) {
				fileProxy.status = 'failed'
				fileProxy.message = '识别失败'
				console.error(e)
				return
			}
			fileProxy.status = 'success'
			fileProxy.message = '识别成功'
		},
		async afterReadNormal(fileProxy) {
			try {
				fileProxy.status = 'uploading'
				fileProxy.message = '上传中...'
				fileProxy.servFile = await uploadFile({ file: fileProxy.file })
			} catch (e) {
				fileProxy.status = 'failed'
				fileProxy.message = '上传失败'
				console.error(e)
				return
			}
			fileProxy.status = 'success'
			fileProxy.message = '上传成功'
		},
		async fetchProductDetail() {
			this.detailLoading = true
			productDetail(this.productId)
				.then((res) => {
					this.productDetail = res.data
					this.activeGuaId = res.data.guarantees[0].id

					this.agrees = [
						{
							content: res.data.specialAgreement,
							name: '特别约定'
						},
						{
							content: res.data.insuranceNotice,
							name: '投保须知'
						},
						{
							content: res.data.claimsNotice,
							name: '理赔须知'
						},
						{
							content: res.data.exclusion,
							name: '免责声明'
						}
					]
				})
				.finally(() => {
					this.detailLoading = false
				})
		}
	},
	beforeUnmount() {
		clearInterval(this.verifyTimer)
		localStorage.removeItem('waitVerifySecond')
	},
	created() {}
}
</script>

<style lang="scss" scoped>
.nav-tab ::v-deep {
	.van-sticky {
		position: fixed;
		top: -30vw;
		left: 0;
		right: 0;
	}
}
.head {
	overflow: hidden;
	margin-bottom: -50px;
	img {
		display: block;
		width: 100%;
		height: auto;
		// margin-bottom: -$space_3;
	}
}
.photo-box ::v-deep .van-cell {
	width: auto !important;
	padding-bottom: 0 !important;
	padding-inline: 0 !important;
	.van-field__control {
		width: 315px !important;
		height: 220px !important;
	}
}
.shadow {
	box-shadow: 0 0 $space_2 rgba(10, 10, 10, 0.1);
}
.title {
	font-size: $font_medium_x;
	font-weight: 600;
	color: #3b160d;
	margin: 0.8em 0.5em;
	padding-left: 0.5em;
	position: relative;
	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0.07em;
		bottom: 0.05em;
		width: 0.2em;
		background: #5f88ff;
	}
}
.sub-title {
	font-size: $font_medium;
	color: #333;
	margin-bottom: $space_2;
}

.van-label {
	font-size: $font_medium;
	font-weight: 600;
	padding-right: 6px;
}

.red {
	color: $color_err;
}
</style>

<style>
.next-product {
	background-color: transparent !important;
	img {
		border-radius: 30rem;
	}
}
</style>
